import { Injectable } from '@angular/core';
import { BaseHttpService, Query, UriBuilderParams } from './base/base-http.service';
import { HttpServiceBundle } from './base/http-service-bundle.service';
import { VehicleCode } from '../../shared/models/vehicle-code';
import { Observable } from 'rxjs';
import { BaseList } from '../../shared/models/list';
import { VehicleManufacturer } from '../../shared/models/vehicle-manufacturer';
import { DRResponse } from '../../shared/models/response';
import { map } from 'rxjs/operators';
import { BackendUriUnits } from '@app/core/services/base/backend-uri-units';

export class VehicleCodeUriBuilderParams extends UriBuilderParams<VehicleCode> {

  constructor(vehicleCode?: VehicleCode | string) {
    super(vehicleCode);
  }

  public buildUri(): string {
    return this.simpleUriBuild(BackendUriUnits.VEHICLE_CODES);
  }
}

@Injectable({
  providedIn: 'root'
})
export class VehicleSelectionService extends BaseHttpService<VehicleCode, VehicleCodeUriBuilderParams> implements Query<VehicleCode, VehicleCodeUriBuilderParams> {

  constructor(httpServiceBundle: HttpServiceBundle) {
    super(VehicleCode, httpServiceBundle);
  }

  // BASE METHODS ****************************************************************************************

  public query(uriParams: VehicleCodeUriBuilderParams, params?: any): Observable<BaseList<VehicleCode>> {
    return this.queryBase(uriParams, params);
  }

  // ADD-ON METHODS *************************************************************************************

  public queryManufacturers(params?: any): Observable<BaseList<VehicleManufacturer>> {
    const uri = `${this.uri}/${BackendUriUnits.VEHICLE_CODES}/manufacturers`;
    const queryParams = params && params.queryParams ? params.queryParams : null;
    return this.http.get<DRResponse<BaseList<VehicleManufacturer>>>(uri, { params: queryParams })
        .pipe(map(res => {
          return new BaseList(VehicleManufacturer, res.data);
        }));
  }
}
